// import axios from "axios";
// import Cookies from "js-cookie";
// import { redirectToLogin } from "../LoginPage.js/navigationService";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_ENDPOINT,
//   timeout: 10000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Add request interceptor (optional)
// axiosInstance.interceptors.request.use(
//   (config) => {
//     // const token = localStorage.getItem("token");
//     const token = Cookies.get("_auth");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Add response interceptor (optional)
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // navigate("/");
//       redirectToLogin();
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;


import axios from "axios";
import Cookies from "js-cookie";
import { redirectToLogin } from "../LoginPage.js/navigationService";

// Global AbortController
let abortController = new AbortController();

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("_auth");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Attach abort signal to every request
    config.signal = abortController.signal;

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Cancel all in-flight requests
      abortController.abort();

      // Reset controller for future requests (after re-login)
      abortController = new AbortController();

      // Redirect to login
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
